import React from "react";
import { ChoiceGroup, IChoiceGroupOption, PrimaryButton, Spinner, SpinnerSize, Stack } from "@fluentui/react";
import { useDispatch } from "react-redux";
import { LanguageContext } from "../../../../../../utilities/LocalizationModule";
import { setOneDriveOverwriteOptionSelected } from "../../../../redux/modules/file";
import { OneDriveOverWriteEnum } from "../../../enums/oneDriveOverWriteEnum";
import { CheckinTypes } from "../../redux/api/local/api-local-interfaces";

export interface IVersionSelectorProps {
  checkinTypeChanged?: (checkinType: CheckinTypes) => void;
  onCancel?: () => void;
  onSave?: () => void;
  labelFontSize: number;
  paddingTop: number;
  paddingLeft: number;
  isBusy?: boolean;
}

export const VersionSelectorMinMajOnly = (props: IVersionSelectorProps) => {
  const languageStrings = React.useContext(LanguageContext);

  const dispatch = useDispatch();

  const { checkinTypeChanged } = props;
  const [options] = React.useState<IChoiceGroupOption[]>([
    { key: "0", text: `${languageStrings.VersionMinorDraft}` },
    { key: "1", text: `${languageStrings.VersionMajorPublished}` }
  ]);
  let defaultSelectedKey = "0";

  const _onChange = (ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption): void => {
    checkinTypeChanged(+option.key);
  }

  return (
    <>
      <div style={{ paddingTop: props.paddingTop, paddingLeft: props.paddingLeft }}>
        <ChoiceGroup defaultSelectedKey={defaultSelectedKey} options={options} onChange={_onChange} label={languageStrings.ChooseVersion} required={true} styles={{ label: { fontSize: `${props.labelFontSize}px` } }} />
        <Stack tokens={{ childrenGap: 10 }} horizontal>
          {props.onSave &&
            <PrimaryButton onClick={() => {
              props.onSave();
            }}
              style={{ marginTop: "20px" }} text={languageStrings.Save} disabled={props?.isBusy}>{props?.isBusy && <Spinner size={SpinnerSize.small} style={{ paddingLeft: '5px' }} />}</PrimaryButton>}
          {props.onCancel &&
            <PrimaryButton onClick={() => {
              dispatch(setOneDriveOverwriteOptionSelected(OneDriveOverWriteEnum.notSelected));
              props.onCancel();
            }}
              style={{ marginTop: "20px" }} disabled={props?.isBusy}>{languageStrings.Cancel}</PrimaryButton>}
        </Stack>
      </div>
    </>
  );
};